import axios from '../utils/axios';

const baseUrl = `/api/salesTeamRoles`;

export const fetchSalesTeamRoleList = async () => {
  const requestUrl = `${baseUrl}`;
  return await axios.get(requestUrl);
};
